import { createSlice } from '@reduxjs/toolkit';

interface PolicySliceState {
  isChatPolicyAccepted: boolean;
  isChatPolicyRejected: boolean;
  chatPolicyContent: string;
  isNewChatPolicyAvailable: boolean;
  newChatPolicyTooltipShown: boolean;
}

const initialState: PolicySliceState = {
  isChatPolicyAccepted: false,
  isChatPolicyRejected: false,
  chatPolicyContent: '',
  isNewChatPolicyAvailable: false,
  newChatPolicyTooltipShown: false,
};

export const policySlice = createSlice({
  name: 'policy',
  initialState,
  reducers: {
    setChatPolicyAccepted: (state, action) => {
      state.isChatPolicyAccepted = action.payload;
      state.isChatPolicyRejected = false;
    },
    setChatPolicyRejected: (state, action) => {
      state.isChatPolicyRejected = action.payload;
    },
    setChatPolicyContent: (state, action) => {
      state.chatPolicyContent = action.payload;
    },
    setNewChatPolicyAvailable: (state, action) => {
      state.isNewChatPolicyAvailable = action.payload;
    },
    setNewChatPolicyTooltipShown: (state, action) => {
      state.newChatPolicyTooltipShown = action.payload;
    },
  },
});
